/**********************************************************
Chemical Application Form
**********************************************************/
import { TextInput, NumberInput, DatePicker,
    RadioButton, SelectField, Select } from '../inputs';
  import { ISSUE_OR_RECEIVE } from '../../cult_constants';
  import React, { Component } from 'react';
  import PropTypes from 'prop-types';
  import moment from 'moment';
  
  const propTypes = {
    formType: PropTypes.string,
    fields: PropTypes.array,
    approvers: PropTypes.array,
    setFormType: PropTypes.func,
    fetchFields: PropTypes.func
  };
  
  class TreeInventoryEditForm extends Component {
    render() {
      if (!this.props.formId) return <div></div>
      return (
        <div id="tree-inventory-editform">
          <h3 className="blue-text">Edit Inventory Transaction</h3>< hr />
          <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col s12 m4 l4 xl4">
                <DatePicker id={'treeInvEdit-date'} label={'Date'} min={'2019-01-01'} max={moment().format('YYYY-MM-DD')} required={true} />
              </div>
              <div className="col s12 m4 l4 xl4">
                <label>Location</label>
                <div className="radio-flex">
                  <RadioButton id={'treeInvEdit-kau'} name={'treeInvEdit-location'} value={'71'} label={'Kau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                  <RadioButton id={'treeInvEdit-keaau'} name={'treeInvEdit-location'} value={'72'} label={'Keaau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                </div>
              </div>
              <div className="col s12 m4 l4 xl4">
                <SelectField id={'treeInvEdit-field'} label={'Inventory Field'} opts={this.props.fields.filter((f) => f.field.match(/NK29|N000|N001/))} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m4 l4 xl4">
                <Select id={'treeInvEdit-issuedOrReceived'} label={'Issue or Receivable'} opts={ISSUE_OR_RECEIVE} />
              </div>
              <div className="col s12 m4 l4 xl4">
                <NumberInput id={'treeInvEdit-quantity'} label={'Quantity'} step={"1.0"} min={"0"} />
              </div>
              <div className="col s12 m4 l4 xl4">
                <TextInput id={'treeInvEdit-comments'} label={'Comments'} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l12 xl12">
                <label>Approver</label>
                <div className="check-flex">
                  {
                    this.props.approvers.map((a, i) => (
                      <div key={a.id} className="ml-2">
                        <RadioButton id={`treeInvEdit-approver${i+1}`} name={'treeInvEdit-approver'} label={a.name} value={a.eid} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      );
    }
  }
  
  TreeInventoryEditForm.propTypes = propTypes;
  export default TreeInventoryEditForm;
  
  
  
  /* END */
  


// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_edit_form.js